<template>
  <section>
    <!-- Multi photos template -->
    <template v-if="expPhotos.length >= numPhotos">
      <div class="section-experience-photos" @mouseover="mouseOver" @mouseout="mouseOut">
        <div class="main-grid-experience-photos h-100">
          <div class="first-col-experience-photos bg-dark" style="border-right: 4px solid white;">
            <div class="embed-responsive embed-responsive-16by9" v-if="isVideo(experience.experience_photos[0].image_sm)">
              <iframe class="embed-responsive-item" :src="experience.experience_photos[0].image_sm" allowfullscreen></iframe>
            </div>
            <img v-lazy="expPhotos[0].image_xl"
                 :alt="expPhotos[0].title"
                 class="img-experience-photo"
                 :class="{'img-experience-effect': isHovered}"
                 @click="$parent.openGallery(0)"
                 v-else>
          </div>
          <div style="border-left: 4px solid white;">
            <div class="second-col-experience-photos">
              <template v-for="(photo, index) in expPhotos" v-if="index > 0 && index < numPhotos">
                <div class="sub-grid-experience-photos bg-dark"
                     :class="[index === 2 ? 'rounded-top-right' : '',
                              index === 4 ? 'rounded-bottom-right' : '']">
                  <img v-lazy="photo.image_sm"
                       :alt="photo.title"
                       class="img-experience-photo"
                       :class="{'img-experience-effect': isHovered}"
                       @click="$parent.openGallery(index)">
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="section-view-photos p-2">
          <div class="bg-white border border-dark rounded py-2 px-3 text-small" @click="$parent.openGallery(0)">
            <i class="fas fa-th"></i>&nbsp;{{ $t('message.professional.menu.view_photos') }}
          </div>
        </div>
      </div>
    </template>
    <!-- Single photo template -->
    <template v-else>
      <div class="section-experience-photos" @mouseover="mouseOver" @mouseout="mouseOut">
        <div class="cover-experience-photo bg-dark">
          <div class="embed-responsive embed-responsive-16by9" v-if="isVideo(experience.experience_photos[0].image_sm)">
            <iframe class="embed-responsive-item" :src="experience.experience_photos[0].image_sm" allowfullscreen></iframe>
          </div>
          <img v-lazy="expPhotos[0].image_xl"
               :alt="expPhotos[0].title"
               class="img-experience-photo"
               :class="{'img-experience-effect': isHovered}"
               @click="$parent.openGallery(0)"
               v-else>
        </div>
        <div class="section-view-photos">
          <div class="bg-white border border-dark rounded py-2 px-3 text-small" @click="$parent.openGallery(0)">
            <i class="fas fa-th"></i>
            {{ $t('message.professional.menu.view_photos') }}
          </div>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
  import fileHelpers from '../../../helpers/fileHelpers'

  export default {
    props: {
      numPhotos: Number,
      experience: Object
    },
    data () {
      return {
        isHovered: false,
        expPhotos: []
      }
    },
    methods: {
      mouseOver () {
        this.isHovered = true
      },
      mouseOut () {
        this.isHovered = false
      },
      isVideo (url) {
        return fileHelpers.isVideo(url)
      }
    },
    mounted () {
      if (this.experience && this.experience.experience_photos.length > 0) {
        for (const experiencePhoto of this.experience.experience_photos) {
          if (!fileHelpers.isVideo(experiencePhoto.image_xl)) {
            this.expPhotos.push(experiencePhoto)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/experience/components/PhotosDesktop.vue